import React from 'react';
import PropTypes from 'prop-types';
import DateRangePicker from 'rsuite/DateRangePicker';
import { useSelector } from 'react-redux';
import { FiltersDetailsUseStyles } from 'components/common/components/filters/FiltersUseStyles';
import './RangeDateTimePickerUseStyles.scss';
import UserSessionDataHandler from 'auth/UserSessionsDataHandler';
import plLocale from 'date-fns/locale/pl';
import enLocale from 'date-fns/locale/en-US';
import { Grid } from '@material-ui/core';
import moment from 'moment-timezone';
// import RangeDateTimePickerLocale from './RangeDateTimePickerLocale';

moment.tz.setDefault('UTC');

const LocaleMap = {
  pl: plLocale,
  en: enLocale,
};

const RangeDateTimePicker = props => {
  const {
    handleStartDateChange,
    handleEndDateChange,
    selectedStartDate,
    selectedEndDate,
  } = props;
  const language = useSelector(state => state.language);
  const userSettingObject = UserSessionDataHandler.getUserSettingsObject();
  const lang = userSettingObject[UserSessionDataHandler.defaultLanguage];
  const [dateValue, setDateValue] = React.useState([null, null]);

  const classesFilter = FiltersDetailsUseStyles();

  const handleChangeDateTime = value => {
    if (value !== null) {
      handleStartDateChange(new Date(value[0].toUTCString()).getTime());
      handleEndDateChange(new Date(value[1].toUTCString()).getTime());
      setDateValue([value[0], value[1]]);
    }
  };

  React.useEffect(() => {
    if (selectedStartDate === 0 && selectedEndDate === 0)
      setDateValue([null, null]);
  }, [selectedStartDate, selectedEndDate]);

  return (
    <Grid container alignItems="center" direction="row" spacing={1}>
      <Grid
        item
        xs={2}
        className={`${classesFilter.FiltersDetails}__table__filters__add__form__label`}
      >
        {language.filtersComponentv2.calendar_}
      </Grid>
      <Grid item xs={10}>
        <DateRangePicker
          locale={LocaleMap[lang]}
          format="yyyy-MM-dd HH:mm:ss"
          onChange={handleChangeDateTime}
          cleanable={false}
          value={dateValue}
        />
      </Grid>
    </Grid>
  );
};
RangeDateTimePicker.propTypes = {
  selectedStartDate: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.oneOf([PropTypes.instanceOf(null)]).isRequired,
  ]),
  selectedEndDate: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.oneOf([PropTypes.instanceOf(null)]).isRequired,
  ]),
  handleStartDateChange: PropTypes.func.isRequired,
  handleEndDateChange: PropTypes.func.isRequired,
};

export default RangeDateTimePicker;
